import type { QueryResult } from 'react-apollo';

import { keys as sessionStorageKeys } from '@confluence/storage-manager';

import type {
	FeedContentQuery as FeedContentQueryType,
	FeedContentQueryVariables,
} from './__types__/FeedContentQuery';
import { FollowingFeedSortByValue } from './Feed';
import { useFeedDropdownStorage } from './useFeedDropdownStorage';
import { FeedContentQuery } from './FeedContentQuery.graphql';

export const useFollowingFeedWithSortByStorage = (): {
	followingFeedSortBy: FollowingFeedSortByValue;
	setFollowingFeedSortBy: (sorting: FollowingFeedSortByValue) => void;
	followingFeedQuery: QueryResult<FeedContentQueryType, FeedContentQueryVariables>;
} => {
	const { value, setValue, query } = useFeedDropdownStorage<
		FeedContentQueryType,
		FeedContentQueryVariables,
		FollowingFeedSortByValue
	>(
		{
			defaultValue: FollowingFeedSortByValue.Relevant,
			sessionStorageKey: sessionStorageKeys.HOME_FOLLOWING_FEED_SORTING,
			skipQuery: false,
		},
		{
			query: FeedContentQuery,
			variables: (sorting: FollowingFeedSortByValue): FeedContentQueryVariables => ({
				sortBy: sorting,
			}),
		},
	);

	return {
		followingFeedSortBy: value,
		setFollowingFeedSortBy: setValue,
		followingFeedQuery: query,
	};
};
